import cryptoJs from 'crypto-js';


 const secretKey = '12345678901234567890123456789012' // 32자리 비밀키
 const iv = 'abcdefghijklmnop' // 16자리 iv
 
 
export const decrypt = (encryptedText) => {
  // API 응답에서 email이 null/undefined로 내려오는 경우가 있어 안전하게 처리한다.
  if (encryptedText === null || encryptedText === undefined || encryptedText === "") {
    return "";
  }

  // 문자열이 아닌 값은 화면 표시용으로 문자열 변환한다.
  if (typeof encryptedText !== "string") {
    return String(encryptedText);
  }

  try {
    const decipher = cryptoJs.AES.decrypt(encryptedText, cryptoJs.enc.Utf8.parse(secretKey), {
      iv: cryptoJs.enc.Utf8.parse(iv),
      padding: cryptoJs.pad.Pkcs7,
      mode: cryptoJs.mode.CBC,
    });

    const decrypted = decipher.toString(cryptoJs.enc.Utf8);

    // 복호화 결과가 비어있으면 원본을 그대로 보여 크래시를 방지한다.
    return decrypted || encryptedText;
  } catch (error) {
    return encryptedText;
  }
 }
 
